import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from './../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
// import * as urls from '../oldReportsUrls'
import moment from 'moment/moment'
import { appendToUrl, diffInMonths, focusElemnt, getInt, isEmpty, navigation3 } from '../../../common/helper'
import Datepicker from '../../../common/datePicker'
import QuickViewCitywiseBranchwise from './QuickViewCitywiseBranchwise'
import QuickViewBranchwise from './QuickViewBranchwise'
import { cityBranchColumns, cityWiseColumns, selectOptions, updateCityBranchData } from './constants'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { getQuikViewTableData } from '../../../../store/reports/reports_action'
import ManageColumns from '../../../common/ManageColumnsUI'
import * as mdt from '../../../common/modaltypes'
import { SAINI_TRAVELS } from '../../../../helper/companyIdhardcode'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
const QuickViewReport = (props) => {
  const {
    data: { common, reports },
    updateAlertError,
    getQuikViewTableData,
    updateModal,
  } = props

  const { loginData: reduxLoginData = {}, roleRights, showModal, modalType, companySettings } = common
  const [searchParams] = useSearchParams()
  let { loginData = {} } = useToken()
  let isFromUrl = false
  let { AllowViewAllBranchReport, AllowExportExcel } = { ...roleRights?.Table1?.[0] }
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = Number(searchParams.get('C') || 0)
    loginData.intBranchCityID = Number(searchParams.get('CT') || 0)
    loginData.strCityName = searchParams.get('CTN') || ''
    loginData.intUserID = Number(searchParams.get('U') || 0)
    loginData.intBranchID = Number(searchParams.get('B') || 0)
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    loginData.IsBranchAdmin = Number(searchParams.get('IBA') || 0)
    loginData.IsMTPLAdmin = Number(searchParams.get('IMPTLA') || 0)
    loginData.IsAdmin = Number(searchParams.get('IA') || 0)
    AllowViewAllBranchReport = Number(searchParams.get('AllowViewAllBranchReport') || 0)
    AllowExportExcel = Number(searchParams.get('AllowExportExcel') || 0)
    isFromUrl = true
  }
  if (!isEmpty(reduxLoginData)) {
    loginData = reduxLoginData
  }
  const { intCompanyID } = loginData
  const UseToPayAsCOD = companySettings?.[0]?.UseToPayAsCOD || Number(searchParams.get('UseToPayAsCOD') || 0)
  const { quikViewTableData } = reports
  const reportName = 'Quick View'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [disableExcel, setDisableExcel] = useState(false)
  const [selectedOption, setSelectedOption] = useState(selectOptions?.[0])
  const [showTable, setShowTable] = useState(false)
  const [showTableData, setShowTableData] = useState([])
  const [cityId, setCityId] = useState(false)
  const [manageColCitywise, setManageColCitywise] = useState([])
  const [manageColBranchWise, setManageColBranchWise] = useState([])
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  let headers = []
  if (selectedOption?.id == 0) {
    headers = manageColCitywise.map((col) => ({
      ...col,
      align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
      exportHead: col.header,
    }))
  } else {
    headers = manageColBranchWise.map((col) => ({
      ...col,
      align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
      exportHead: col.header,
    }))
  }

  const headerData = {
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    selectedOption: selectedOption?.name,
  }

  const QuickViewFilterHeaders = [
    { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
    { field: 'toDate', header: 'To  Date', textAlign: 'left' },
    { field: 'selectedOption', header: 'Selected Option', textAlign: 'left' },
  ]

  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])

  useEffect(() => {
    if ((isFromUrl || !isEmpty(roleRights)) && !isEmpty(loginData)) {
      setCityId(
        !(
          loginData.IsBranchAdminUser ||
          loginData.IsBranchAdmin ||
          loginData.IsMTPLAdminUser ||
          loginData.IsMTPLAdmin ||
          loginData.IsAdmin ||
          AllowViewAllBranchReport
        )
      )
      setDisableExcel(!AllowExportExcel)
    }
  }, [roleRights, loginData, isFromUrl, AllowViewAllBranchReport, AllowExportExcel])
  useEffect(() => {
    if (!isEmpty(quikViewTableData)) {
      const updatedTable = [...quikViewTableData.Data.Table] || []
      const updateData = updateCityBranchData(updatedTable)
      setShowTableData(updateData)
    } else {
      setShowTableData([])
    }
  }, [quikViewTableData])

  // const handleClick1 = () => {
  //   if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
  //     updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
  //   } else {
  //     if (selectedOption === "" || selectedOption === " ") {
  //       updateAlertError({ show: true, msg: 'Select Company User', nextId: '' })
  //     } else {
  //       setShowTable(true)
  //       const obj = {
  //         CompanyID: loginData?.intCompanyID,
  //         BranchID: loginData?.intBranchID,
  //         CityID: cityId ? loginData?.intBranchCityID : 0,
  //         FromDate: moment(fromDate).format("YYYY-MM-DD"),
  //         ToDate: moment(toDate).format("YYYY-MM-DD"),
  //         IsBranchwise: selectedOption?.id === 0 ? 1 : 0,
  //       }
  //       getQuikViewTableData(obj)
  //     }
  //   }
  // }
  const handleClick1 = (isPdf = false) => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > 31 * 24 * 60 * 60 * 1000) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }
    if (selectedOption === '' || selectedOption === ' ') {
      setAlert({ show: true, msg: 'Select Company User', nextId: '' })
      return
    }
    setLoader(true)
    const obj = {
      CompanyID: loginData?.intCompanyID,
      BranchID: loginData?.intBranchID,
      CityID: cityId ? loginData?.intBranchCityID : 0,
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      IsBranchwise: selectedOption?.id === 0 ? 1 : 0,
    }
    GetRequest(urls.getQuikViewTableData, obj)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        // const data = formatTableData(res.Data.Table)
        const updatedData = res?.Data?.Table?.map((item) => ({ ...item, dataType: 'entry', }))
        const data = updateCityBranchData(updatedData)
        let manageColumn = selectedOption?.id == 0 ? manageColCitywise : manageColBranchWise
        let mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
          ...val,
          field: val.field,
          align: val.align || val.xlCol?.dataType === 'quantity' ? 'right' : 'left',
          exportHead: val.exportHead || val.header,
          export: val.header,
          weight: 80,
          width: getInt(val.headerSx?.minWidth),
        }))
        data.unshift({ BookedCOD: 'Booked', DeliveredCOD: 'Delivery', dataType: 'subHeader' })
        const reportPayload = {
          reportName,
          criteriaHeaders: QuickViewFilterHeaders,
          criteriaData: [headerData],
          tableData: data,
          mainHeader: mainHeader,
          isShowManageColumn: true,
          manageColumnID: 'quickViewReportColumn',
          showColumnBorders: true,
          
        }
        if (isPdf) {
          downloadPDF({
            reportName,
            criteriaHeaders: QuickViewFilterHeaders,
            criteriaData: [headerData],
            tableData: data,
            visibleColumns: mainHeader,
            loginData,
            hideHeader: false,
          })
          return
        }

        const rid = Date.now().toString()

        if (!window.generatedReports) {
          window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload

        window.open(`/view-report?rid=${rid}`, '_blank')
        // setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleClick2 = () => {
    let url = urls.quickViewReport
    const urlData = urls.quickViewReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDate = fromDate.format('DD-MMM-YYYY')
    urlData.ToDate = toDate.format('DD-MMM-YYYY')
    urlData.IsBranchWise = selectedOption?.id === 0 ? 1 : 0
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelectedOption(selectOptions?.[0])
  }
  useEffect(() => {
    const transformColumns = (columns, limit) => {
      if (UseToPayAsCOD === 1) {
        return columns
          .map((col) => {
            switch (col.field) {
              case 'BookedToPay':
              case 'DeliveredToPay':
                return {
                  ...col,
                  header: 'COD\nAmt.',
                  exportHead: 'COD\nAmt.',
                }
              case 'BookedToPayDDDV':
              case 'DeliveredToPayDDDV':
                return {
                  ...col,
                  header: 'COD DDDV',
                  exportHead: 'COD DDDV',
                }
              default:
                return col
            }
          })
          .filter((col) => !['BookedCOD', 'DeliveredCOD'].includes(col.field))
      }

      if (SAINI_TRAVELS === loginData?.intCompanyID) {
        return columns.filter((col) => col.id <= limit)
      }

      return columns
    }

    try {
      setManageColCitywise(transformColumns(cityBranchColumns, 15))
      setManageColBranchWise(transformColumns(cityWiseColumns, 14))
    } catch (error) {
      console.error(error)
      setManageColCitywise(cityBranchColumns)
      setManageColBranchWise(cityWiseColumns)
    }
  }, [UseToPayAsCOD, loginData])
  
  const options = ['GENERATE NEW FORMAT']
  if (intCompanyID !== SAINI_TRAVELS) {
    options.push('GENERATE OLD FORMAT')
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
      {!isFromUrl && <ReportHeading reportName={reportName} />}
      <Box sx={{ ...sx.reportFlex, gap: isFromUrl ? '15px' : '10px' }}>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: isFromUrl ? 'auto' : '350px' }} className="input--container bookingDatePicker">
          <Datepicker
            name={'Transaction From Date'}
            label={'Transaction From Date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              setShowTable(false)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: isFromUrl ? 'auto' : '350px' }} className="input--container bookingDatePicker">
          <Datepicker
            label={'Transaction To Date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              setShowTable(false)
              focusElemnt('seletedOption')
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: isFromUrl ? 'auto' : '310px' }}>
          <DropDownOA
            id="seletedOption"
            label={'Select Options'}
            searchPlaceholder={`Search Select Options`}
            defaultvalue={selectedOption?.name || selectedOption}
            data={selectOptions || []}
            dataKey={`name`}
            idKey={`id`}
            width="100%"
            // disabled={disableBtn}
            onSelect={(obj) => {
              setSelectedOption(obj)
              setShowTable(false)
            }}
            nextId={'SplitButton'}
            prevId={id.toDate}
          />
        </Item>
        {isFromUrl ? (
          <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom: '10px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id="SplitButton">
            DOWNLOAD PDF
          </Button>
        ) : (
          <>
            <Item
              sx={sx.itemsx}
              onKeyDown={(e) =>
                navigation3(e, showTable ? (disableExcel ? 'ExportToPdf' : 'ExportToExl') : id.fromDate, 'seletedOption', () => handleClick1())
              }
            >
              <SplitButton
                options={options}
                // hideToggle={true}
                // onClick1={handleClick1}
                onClick1={() => handleClick1(false)}
                onClick2={handleClick2}
                id1={'SplitButton'}
              />
            </Item>
            <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
              <RefreshSvg width={'24px'} height={'24px'} />
            </Item>
          </>
        )}
      </Box>
      <Item>
        {showTable ? (
          selectedOption?.id == 0 ? (
            <QuickViewCitywiseBranchwise
              UseToPayAsCOD={UseToPayAsCOD}
              updateModal={updateModal}
              headerData={headerData}
              disableExcel={disableExcel}
              tableHeader={manageColCitywise.filter((obj) => obj.isSelected)}
              tableData={showTableData || []}
            />
          ) : (
            <QuickViewBranchwise
              UseToPayAsCOD={UseToPayAsCOD}
              headerData={headerData}
              disableExcel={disableExcel}
              tableData={showTableData || []}
              updateModal={updateModal}
              tableHeader={manageColBranchWise.filter((obj) => obj.isSelected)}
            />
          )
        ) : (
          ''
        )}
        {/* */}
      </Item>
      {/* {showModal && mdt.manageColQuickView === modalType ? <ManageColumns headers={manageColCitywise} onSave={onSaveCityWiseColumns} updateModal={updateModal} /> : null}
      {showModal && mdt.manageColQuickViewBranch === modalType ? <ManageColumns headers={manageColBranchWise} onSave={onSaveBranchWiseColumns} updateModal={updateModal} /> : null} */}
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getQuikViewTableData, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(QuickViewReport)
